<template>
    <div v-if="mission">
        <div class="table-responsive">
            <table class="table table-sm align-middle">
                <thead>
                    <tr>
                        <th>Convoi</th>
                        <th class="text-end" style="width:120px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="balise in (mission.balises || [])" :key="balise.id">
                        <td>
                            <VehicleNameDisplay :balise="balise" />
                        </td>
                        <td class="text-end">
                            <button class="btn btn-sm btn-outline-danger" @click="removeBalise(balise)">
                                Supprimer
                            </button>
                        </td>
                    </tr>
                    <tr v-if="!mission.balises?.length">
                        <td colspan="2" class="text-muted">Aucun véhicule dans le convoi.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Ajout -->
        <div class="py-3">
            <div class="row g-3 align-items-center">
                <div class="col-auto"><strong>Ajouter :</strong></div>
                <div class="col">
                    <BaliseSelect @baliseChange="addBalise" />
                </div>
            </div>
            <hr class="my-3" />
            <div class="row g-3 align-items-center">
                <div class="col-auto"><strong>Par groupe :</strong></div>
                <div class="col">
                    <select class="form-select" v-model="selectedGroupId" @change="onGroupChange"
                        :disabled="isAddingGroup">
                        <option disabled value="">— Ajouter par groupe —</option>
                        <option v-for="g in groups" :key="g.id" :value="g.id">{{ g.name }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaliseSelect from '@/components/display/BaliseSelect.vue'
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'
import GroupService from '@/services/group.service'
import MissionService from '@/services/mission.service'

export default {
    name: 'ConvoyEditor',
    props: { mission: { type: Object, required: true } },
    components: { BaliseSelect, VehicleNameDisplay },
    emits: ['refresh'],
    data() {
        return {
            groups: [],
            selectedGroupId: '',
            isAddingGroup: false
        };
    },
    mounted() {
        GroupService.getClientGroups()
            .then(res => {
                this.groups = Array.isArray(res.data) ? res.data.map(g => ({ id: g.id, name: g.name })) : [];
            })
            .catch(console.log);
    },
    methods: {
        addBalise(balise) {
            if (!this.mission?.id || !balise?.id) return;
            MissionService.addMissionBalise({ baliseId: balise.id }, this.mission.id)
                .then(() => this.$emit('refresh'))
                .catch(console.log);
        },
        removeBalise(balise) {
            if (!this.mission?.id || !balise?.id) return;
            MissionService.removeMissionBalise({ baliseId: balise.id }, this.mission.id)
                .then(() => this.$emit('refresh'))
                .catch(console.log);
        },
        addGroup() {
            if (!this.mission?.id || !this.selectedGroupId) return;
            this.isAddingGroup = true;
            const gid = Number(this.selectedGroupId);
            MissionService.addMissionBalisesByGroups(this.mission.id, [gid])
                .then(() => this.$emit('refresh'))
                .catch(console.log)
                .finally(() => {
                    this.selectedGroupId = '';
                    this.isAddingGroup = false;
                });
        },
        onGroupChange() {
            if (!this.selectedGroupId) return;
            this.addGroup();
        }
    }
}
</script>
